import styled from "styled-components";

export const Main = styled.div<{ $isMinimize: boolean }>`
   border: 1px solid rgb(226, 232, 240);
   box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
   border-radius: 15px;

   #subAgent{
      position: absolute;
      left: 43px;
      top: 7px;
      color: #06b6d4;
      z-index: 1;
      font-family: monospace;
      font-size: 15px;
   }

   #warning {
      position: absolute;
      top: -1px;
      left: -1px;
      border: 1px solid #EF6C25;
      border-radius: 16px;
      width: calc(100% + 2px);
      height: calc(100% + 2px);
      z-index: -1;
   }
   #warningIcon {
      position: absolute;
      left: 10px;
      top: 8px;
      color: #EF6C25;
      z-index: 1;
   }
   #ran{
    position: absolute;
      top: -1px;
      left: -1px;
      border: 1px solid #339966;
      border-radius: 16px;
      width: calc(100% + 2px);
      height: calc(100% + 2px);
      z-index: -1;
   }
      #ranIcon{
      position: absolute;
      left: 10px;
      top: 8px;
      color: #339966;
      z-index: 1;
   }
   &.anthropic .mainTitle .otherSvg {  
      width: 20px;
      height: 20px;
   }
   .mainTitle {
      position: relative;
      display: flex;
      align-items: center;
      padding: ${({ $isMinimize }) => $isMinimize ? '30px 30px 11px' : '30px 30px 15px'};
      background-color: #fff;
      border-radius: 15px 15px 0 0;

      > div:first-of-type {
         display: flex;
         align-items: center;
         justify-content: center;
         width: ${({ $isMinimize }) => $isMinimize ? 'calc(100% - 30px)' : '40px'};
         height: ${({ $isMinimize }) => $isMinimize ? '60px' : '40px'};
         border-radius: 10px;
         margin-right: 15px;

         svg {
            color: #fff;
            font-size: ${({ $isMinimize }) => $isMinimize ? '32px' : '20px'};;
         }
         .otherSvg {
            ${({ $isMinimize }) => $isMinimize ? `
               width: 32px;
               height: 32px;
            ` : `
               width: 20px;
               height: 20px;
            `};
            svg {
               fill: #fff;
               path { fill: #fff; }
            }
         }
      }
      > div:nth-of-type(2) {
         h5 {
            font-size: 16px;
            font-weight: 500;
         }
         > div {
            display: flex;
            align-items: center;
         }
         .index {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-top: 5px;
            font-size: 15px;
            font-weight: 500;
            z-index: 1;
            padding: 5px 10px;

            > span:first-of-type {
               position: absolute;
               width: 100%;
               height: 100%;
               z-index: -1;
               opacity: 0.18;
               border-radius: 25px;
            }
         }
         .remove {
            display: flex;
            align-items: center;
            margin-left: 5px;
            cursor: pointer;
            transition: all .2s ease-in-out;
            padding: 0 5px;
            opacity: 0.4;

            &:hover {
               opacity: 1;
               color: #F05454;
            }
         }
      }
      .settings {
         display: flex;
         flex-direction: ${({ $isMinimize }) => $isMinimize ? 'column' : 'row'};
         position: absolute;
         right: 20px;
         opacity: 0.65;
         cursor: pointer;

         span {
            transition: all .2s ease-in-out;

            &:hover {
               opacity: 0.65;
            }
         }
         span:first-of-type {
            margin-bottom: ${({ $isMinimize }) => $isMinimize ? '5px' : '0'};
            margin-right: ${({ $isMinimize }) => $isMinimize ? '0' : '10px'};
         }
      }
   }
   .content {
      background-color: #fff;
      padding: 20px;
      padding-top: 0;
      min-width: 80px;
      min-height: ${({ $isMinimize }) => $isMinimize ? '0' : '30px'};;
      border-radius: 0 0 15px 15px;
   }
   .agentChat{
      margin-top: 5px;
   }
`;